import React, { createContext, useContext, useState, ReactNode } from 'react';

interface WhatsAppContextType {
  message: string | null;
  setMessage: (message: string | null) => void;
  clearMessage: () => void;
}

const WhatsAppContext = createContext<WhatsAppContextType | undefined>(undefined);

export function WhatsAppProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null);

  const clearMessage = () => {
    setMessage(null);
  };

  return (
    <WhatsAppContext.Provider value={{ message, setMessage, clearMessage }}>
      {children}
    </WhatsAppContext.Provider>
  );
}

export function useWhatsApp() {
  const context = useContext(WhatsAppContext);
  if (context === undefined) {
    throw new Error('useWhatsApp must be used within a WhatsAppProvider');
  }
  return context;
}

